import * as actionTypes from './actionTypes';
import apiCall from './../app/apiCall.js';

export const fetchReportsListRequest = () => (
  { type: actionTypes.FETCH_REPORTSLIST_REQUEST }
);
export const fetchReportsListSuccess = data => (
  { type: actionTypes.FETCH_REPORTSLIST_SUCCESS, data }
);
export const fetchReportsListFailure = message => (
  { type: actionTypes.FETCH_REPORTSLIST_FAILURE, message }
);
export function fetchReportsList(staffId) {
  return (dispatch) => {
    dispatch(fetchReportsListRequest());
    (apiCall(`reports/available?staffId=${staffId}`)
      .then((response) => {
        dispatch(fetchReportsListSuccess(response.data));
      })
  .catch((error) => {
    dispatch(fetchReportsListFailure(error));
  }));
  };
}
